import React from "react"

export const PictureMosaicLoading = ({preloadProgress}) => {
  const style = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    gap: "5px",
  }

  const currentProgressPercentage = Math.floor(preloadProgress)
  return <div style={style}>
    <div className="progress"
         role="progressbar"
         aria-label="Loading percentage"
         aria-valuenow={currentProgressPercentage}
         aria-valuemin="0"
         aria-valuemax="100"
          style={{width: "100%", maxWidth: "150px", height: "5px"}}
    >
      <div className="progress-bar bg-dark" style={{width: `${currentProgressPercentage}%`}}></div>
    </div>
    <div>
      {currentProgressPercentage}%
    </div>
  </div>
}